import Swiper, { Navigation, Pagination } from 'swiper'

export default class SwiperSlider {
    init(): void {
        this.videoSwipper()
    }

    videoSwipper(): void {
        const fiches = document.querySelectorAll('.swiper-fiches-wrapper')

        if (fiches instanceof NodeList) {
            fiches.forEach((fiche: Element): void => {
                const element = fiche.querySelector('.swiper-fiches')
                const nextEl = fiche.querySelector('.swiper-button-next')
                const prevEl = fiche.querySelector('.swiper-button-prev')

                element instanceof HTMLElement &&
                    nextEl instanceof HTMLElement &&
                    prevEl instanceof HTMLElement &&
                    new Swiper(element, {
                        modules: [Navigation, Pagination],
                        // Optional parameters
                        slidesPerView: 1,
                        speed: 400,
                        spaceBetween: 27,
                        autoHeight: false,
                        direction: 'horizontal',
                        loop: false,
                        effect: 'fade',
                        fadeEffect: { crossFade: true },
                        threshold: 10,

                        // If we need pagination
                        pagination: {
                            el: '.swiper-pagination'
                        },

                        // Navigation arrows
                        navigation: {
                            nextEl,
                            prevEl
                        },

                        // Responsive breakpoints
                        breakpoints: {
                            // when window width is >= 320px
                            320: {
                                slidesPerView: 1,
                                spaceBetween: 20,
                                centeredSlides: true
                            },
                            // when window width is >= 768px
                            769: {
                                slidesPerView: 2,
                                spaceBetween: 27
                            },
                            // when window width is >= 1280px
                            1280: {
                                slidesPerView: 3,
                                spaceBetween: 27
                            }
                        }
                    })
            })
        }
    }
}
